import React from 'react';
import {
    Grid,
    Paper,
    Table,
    TableBody,
} from 'material-ui';
import PageVersionsTableHeader from './PageVersionsTableHeader';
import PageVersionsTableContent from './PageVersionsTableContent';
import {BackButton} from '../../../components/buttons/BackButton';

class PageVersionsTable extends React.Component {

    render() {
        const {
            classes,
            pageId,
            page,
            pageVersions,
            handleOpenDelete,
            openViewPageVersionPopup,
            fetchPageVersion
        } = this.props;

        let sortedPageVersions = pageVersions.sort((a, b) => b.id - a.id);

        return (
            <span>
                {pageVersions.length === 0 ?
                    <Paper elevation={2} className={classes.rootVersionsTable}>
                        <div className={classes.messageNoEntries}>There are no versions for this page! Please edit the page content first!</div>
                    </Paper>
                :
                <Paper elevation={2} className={classes.rootVersionsTable}>
                    <div className={classes.lead}>Versions for Page <em>{page.title}</em></div>
                    <Table className={classes.table}>
                        <PageVersionsTableHeader
                            classes={classes}
                        />
                        <TableBody>
                            {sortedPageVersions.map(version =>
                                <PageVersionsTableContent
                                    key={version.id}
                                    version={version}
                                    handleOpenDelete={handleOpenDelete}
                                    classes={classes}
                                    page={page}
                                    pageId={pageId}
                                    openViewPageVersionPopup={openViewPageVersionPopup}
                                    fetchPageVersion={fetchPageVersion}
                                />
                            )}
                        </TableBody>
                    </Table>
                </Paper>
                }
                <Grid container spacing={16}>
                    <Grid item xs={12} className={classes.backButton}>
                        <BackButton
                            link={"/pages"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </span>
        )
    }
}

export default PageVersionsTable;


// WEBPACK FOOTER //
// ./src/containers/builder/versions/PageVersionsTable.jsx